import {
  OEQ_RESPONSE_CHANGE,
  OEQ_SUBMIT_ANSWER
} from '../../Redux.constants';
import {
  updateResponseArea,
  submitOEQAnswer
} from './helper';

export function OEQReducer(state = {}, action) {
  switch (action.type) {
    case OEQ_RESPONSE_CHANGE:
      return updateResponseArea(state, action.payload);
    case OEQ_SUBMIT_ANSWER:
      return submitOEQAnswer(state, action.payload);
    default:
      return state;
  }
}
